import React from 'react'
import {  Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import AuthDepartsContainer from '../../containers/authmenumng/AuthDepartsContainer';



const AuthMenuMngPage = () => {
    return (
        <>
            <BreadcrumbsContainer title="공통관리/권한별 메뉴관리/부서 권한 리스트" icon="menu"/>
            
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', }}>
                <Box sx={{ width: "360px",mr:1 }}> <AuthDepartsContainer /></Box>
                <Box sx={{ flexGrow: 1 }}>  <Outlet /></Box>
            </Box>
        </>
    )
}

export default AuthMenuMngPage